/* eslint-disable */

import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import * as moment from 'moment';
import { MSRemoteLoggerCategory, MSRemoteLoggerSeverity } from '../adapters/remote-logger/utils/remote-logger.utils';
import { DebugLoggingCapsule } from '../use-case/feature-flags/capsule/debug-logging.capsule';
import { RemoteLoggerUseCase } from '../use-case/remote-logger/remote-logger.use-case';
import { CONSTANTS } from './config.service';
import { DateTimeService } from './date-time/date-time.service';
import { GisService } from './gis.service';
import { LoggerService } from './logger.service';
import { PersonsService } from './persons.service';
import { PosterService } from './poster.service';
import { SqlHelperService } from './sql-helper.service';
import { SchemaService } from './survey/schema.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class TripSurveyService {
  db;
  table = CONSTANTS.tripSurveyTableName;
  longDistanceMode = false;
  rosterFields = null;
  prepopulateFields = null;
  noUpdateFields = ['id', 'firstCompleted', 'lastCompleted', 'completedCount', 'lap', 'maxLapIndex'];
  // TODO - are these the right fields? Compare and contrast
  // baseRosterFields =      ['id', 'complete', 'firstCompleted', this.sqlHelper.getSecondsColAsYmd('startTime', 'startTimeYmd'), 'surveyDate', 'timezoneOffset', 'startTime', 'stopTime', 'startLat', 'startLon', 'stopLat', 'stopLon', 'userEdited', 'teleport', 'rosterAdded', 'addedTourId', 'addedLegId', 'addedTripType', 'addedSuccess', 'pending', 'merged', 'subjectPersonId', 'pickupMeters', 'badStartTime', 'badStopTime', 'badStopLoc', 'userAddedStartTime', 'userAddedStartLoc', 'userAddedStopTime', 'userAddedStopLoc', 'cloned', 'promptToSplit'];
  baseRosterFields = [
    'id',
    'surveyDate',
    'timezoneOffset',
    'complete',
    'firstCompleted',
    'startTime',
    'stopTime',
    'startLat',
    'startLon',
    'stopLat',
    'stopLon',
    'userEdited',
    'teleport',
    'verified',
    'rosterAdded',
    'addedTourId',
    'addedLegId',
    'addedTripType',
    'addedSuccess',
    'pending',
    'merged',
    'subjectPersonId',
    'pickupMeters',
    'badStartTime',
    'badStopTime',
    'badStopLoc',
    'userAddedStartTime',
    'userAddedStartLoc',
    'userAddedStopTime',
    'userAddedStopLoc',
    'cloned',
    'promptToSplit',
    'lastPage'
  ];
  mergeFields = [
    'id',
    'surveyDate',
    'timezoneOffset',
    'startTime',
    'stopTime',
    'startLat',
    'startLon',
    'stopLat',
    'stopLon',
    'userEdited',
    'teleport',
    'verified',
    'rosterAdded',
    'addedTourId',
    'addedLegId',
    'addedTripType',
    'addedSuccess',
    'pickupMeters',
    'badStartTime',
    'badStopTime',
    'badStopLoc',
    'userAddedStartTime',
    'userAddedStartLoc',
    'userAddedStopTime',
    'userAddedStopLoc',
    'cloned',
    'addedLat',
    'addedLon'
  ];
  verifyFields = [
    'id',
    'surveyDate',
    'timezoneOffset',
    'complete',
    'firstCompleted',
    'startTime',
    'stopTime',
    'startLat',
    'startLon',
    'stopLat',
    'stopLon',
    'userEdited',
    'teleport',
    'verified',
    'rosterAdded',
    'addedTourId',
    'addedLegId',
    'addedTripType',
    'addedSuccess',
    'pending',
    'merged',
    'subjectPersonId',
    'pickupMeters',
    'badStartTime',
    'badStopTime',
    'badStopLoc',
    'userAddedStartTime',
    'userAddedStartLoc',
    'userAddedStopTime',
    'userAddedStopLoc',
    'cloned',
    'promptToSplit',
    'lastPage',
    'adjustedStartTime',
    'recordedStartTime',
    'recordedStopTime'
  ];
  basePrepopulateFields = ['id', 'matchedCount'];
  prepopulateFieldsToIgnore = ['copied', 'copiedId', 'startLabel', 'stopLabel'];
  createTableSql =
    'CREATE TABLE IF NOT EXISTS ' +
    this.table +
    ' ( ' +
    'id INTEGER primary key autoincrement, ' +
    'clonedId INTEGER, ' +
    'firstStarted INTEGER, ' +
    'lastStarted INTEGER, ' +
    'firstCompleted INTEGER, ' +
    'lastCompleted INTEGER, ' +
    'completedCount INTEGER DEFAULT 0, ' +
    'complete INTEGER DEFAULT 0, ' + // bool
    'deleteFlag INTEGER DEFAULT NULL, ' + // bool, 'delete' is a js keyword, this col is for the server
    'deleteReason INTEGER DEFAULT NULL,' +
    'hideFromUi INTEGER DEFAULT 0, ' + // bool
    'surveyDate INTEGER, ' +
    'timezoneOffset INTEGER, ' +
    'verified INTEGER DEFAULT 0, ' + // bool
    // allowing multiple surveys per segment - experimenting w/ mode splits
    // WORKAROUND
    // trips/trip surveys are not 1-1, but in short distance mode that's the way they're first created
    // can be null, multiple nulls allowed
    // only used to prevent multiple survey problem from this being in a different db than trip.hasSurvey (can't use transactions)
    // long name to make it clear that this is just an initial condition - this shouldn't be used as a foreign key
    'createdForTripId INTEGER, ' + // UNIQUE ON CONFLICT IGNORE, ' +
    'lastPage TEXT DEFAULT NULL, ' +
    'path TEXT, ' +
    'queued INTEGER DEFAULT 0, ' + // bool
    'matchedCount INTEGER DEFAULT 0, ' +
    //fields directly from trip record
    'pickupMeters INTEGER DEFAULT NULL, ' +
    'appDied INTEGER DEFAULT NULL, ' +
    'locationTimeout INTEGER DEFAULT NULL, ' +
    //fields imputed from trip record
    'badStartTime INTEGER DEFAULT NULL, ' +
    'badStopTime INTEGER DEFAULT NULL, ' +
    'badStopLoc INTEGER DEFAULT NULL, ' +
    //original trip data
    'recordedStartTime INTEGER DEFAULT NULL, ' +
    'recordedStopTime INTEGER DEFAULT NULL, ' +
    //roster added data
    'addedTourId INTEGER DEFAULT NULL, ' +
    'addedLegId INTEGER DEFAULT NULL, ' + // bool
    'addedTripType TEXT DEFAULT NULL, ' +
    'addedSuccess INTEGER DEFAULT NULL, ' + // bool
    'addedLat INTEGER, ' +
    'addedLon INTEGER, ' +
    //survey meta data
    'userEdited INTEGER DEFAULT NULL, ' +
    'rosterAdded INTEGER DEFAULT NULL, ' +
    'teleport INTEGER DEFAULT NULL, ' +
    'promptToSplit INTEGER DEFAULT NULL, ' +
    'confirmed INTEGER DEFAULT NULL, ' +
    //flags if user updates point info
    'userAddedStartTime INTEGER DEFAULT NULL, ' +
    'userAddedStartLoc INTEGER DEFAULT NULL, ' +
    'userAddedStopTime INTEGER DEFAULT NULL, ' +
    'userAddedStopLoc INTEGER DEFAULT NULL, ' +
    'pending INTEGER DEFAULT NULL, ' +
    'merged INTEGER DEFAULT NULL, ' +
    'split INTEGER DEFAULT NULL, ' +
    'cloned INTEGER DEFAULT NULL, ' +
    'startTime INTEGER, ' +
    'stopTime INTEGER, ' +
    'startLat INTEGER, ' +
    'startLon INTEGER, ' +
    'stopLat INTEGER, ' +
    'stopLon INTEGER, ' +
    'startAddress TEXT, ' +
    'stopAddress TEXT, ' +
    // 'startLabel TEXT, ' +
    // 'stopLabel TEXT, ' +

    'takerPersonId INTEGER, ' +
    'subjectPersonId INTEGER, ' +
    // surveys copied from one member to another b/c person traveled with another hh member
    // 'copied INTEGER, ' +
    // 'copiedId INTEGER, ' +

    'adjustedStartTime INTEGER DEFAULT NULL, ' +
    'callCenterAnswered INTEGER DEFAULT 0, ' +
    'futurePath TEXT, ';

  constructor(
    public platform: Platform,
    private logger: LoggerService,
    private utils: UtilsService,
    private gis: GisService,
    private dateTime: DateTimeService,
    private sqlHelper: SqlHelperService,
    private persons: PersonsService,
    private schema: SchemaService,
    private poster: PosterService,
    private debugLoggingCapsule: DebugLoggingCapsule,
    private remoteLogger: RemoteLoggerUseCase,
  ) {
    this.logger.log('Trip survey constructor', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE);
  }

  /************************************************************************************
   * Counting
   ***********************************************************************************/

  // used in matchers for the noTravel question.
  countSurveysByDay(surveyDate) {
    const start = moment(surveyDate, 'YYYYMMDD').unix();
    this.logger.log('looking for trips on', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, surveyDate, start, start + 86399);
    return this.sqlHelper.getCountPromise(this.db, this.table, { startTime_BETWEEN: [start, start + 86399], hideFromUi: 0 });
  }

  // used in matchers for the noTravel question. gets trips reported by the survey subject
  countSurveysByDayForSurveySubject(surveyData) {
    const surveyDate = surveyData.surveyDate;
    const start = moment(surveyDate, 'YYYYMMDD').unix();
    this.logger.log('looking for trips on', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, surveyDate, start, start + 86399);
    return this.sqlHelper.getCountPromise(this.db, this.table, {
      startTime_BETWEEN: [start, start + 86399],
      hideFromUi: 0,
      subjectPersonId: surveyData.subjectPersonId
    });
  }

  // used in matchers for the noTravel question. gets trips where the person traveled another hh member
  countSurveysByDayForTraveler(surveyData) {
    const surveyDate = surveyData.surveyDate;
    const start = moment(surveyDate, 'YYYYMMDD').unix();
    const where = { startTime_BETWEEN: [start, start + 86399], hideFromUi: 0 };

    where['_CB_householders_' + surveyData.subjectPersonId] = 1;

    this.logger.log('looking for trips on', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, surveyDate, start, start + 86399);

    return this.sqlHelper.getCountPromise(this.db, this.table, where);
  }

  // used in matchers
  countPreviousSurveys(currStartSeconds) {
    return this.sqlHelper.getCountPromise(this.db, this.table, { startTime_LE: currStartSeconds });
  }

  // used for badge and status counting
  countUnfinished() {
    return this.sqlHelper.getCountPromise(this.db, this.table, { complete: 0, hideFromUi: 0 });
  }

  countUnfinishedByPersonId(pId) {
    return this.sqlHelper.getCountPromise(this.db, this.table, { complete: 0, hideFromUi: 0, subjectPersonId: pId });
  }

  /************************************************************************************
   * Updating
   ***********************************************************************************/

  update(survey) {
    const updateValues = Object.assign({}, survey);

    this.noUpdateFields.forEach((field) => {
      delete updateValues[field];
    });

    if (survey.complete === 1) {
      if (survey.firstCompleted) {
        // edit - clear match (if any)
        survey.matchedCount = 1;
      } else {
        updateValues.firstCompleted = this.dateTime.getNowSeconds();
      }
      updateValues.lastCompleted = this.dateTime.getNowSeconds();
      updateValues.completedCount_LITERAL = 'completedCount + 1';
    }

    return this.sqlHelper.getUpdatePromise(this.db, this.table, updateValues, { id: survey.id });
    // .then(updateCount => {
    //     this.logger.log('Trip survey updated complete');
    //     // TODO - pubsub
    //     //pubSub.publish(EVENTS.surveyUpdated, survey.complete, survey.id);
    //     // return updateCount;
    //     return this.get(survey.id)
    // })
    // .then(res => {
    //     this.logger.log('Trip survey updated', res);
    //     return Promise.resolve(null);
    // })
  }

  updateSurveyNav(survey) {
    // ignores other fields and just updates nav fields (for previous)
    const updateValues = this.utils.subset(survey, ['path', 'lastPage']);
    return this.sqlHelper.getUpdatePromise(this.db, this.table, updateValues, { id: survey.id });
  }

  /************************************************************************************
   * Manipulating
   ***********************************************************************************/

  split(surveyData, split) {
    /*
            if splitting a trip, we use the original trip survey as the second leg, and create a new trip survey for the first leg.
            the reasoning is, if the user has already answered the survey, the survey responses were relative to the original trip's destination, which is the destination for leg2.
            the question is, how to handle the metadata.
        */
    const promises = [];
    const splitLat = this.gis.getIntLatOrLon(split.lat);
    const splitLon = this.gis.getIntLatOrLon(split.lng);
    const earlierDataToRetain = this.utils.subset(surveyData, [
      'clonedId',
      'surveyDate',
      'timezoneOffset',
      'pickupMeters',
      'badStartTime',
      'recordedStartTime',
      'addedTourId',
      'addedLegId',
      'addedTripType',
      'addedSuccess',
      'rosterAdded',
      'promptToSplit',
      'userAddedStartTime',
      'userAddedStartLoc',
      'merged',
      'cloned',
      'startTime',
      'startLat',
      'startLon',
      'subjectPersonId'
    ]);
    const earlierDataToUpdate = {
      userEdited: surveyData.rosterAdded || split.isOffPath || surveyData.badStartTime,
      teleport: split.isOffPath || surveyData.badStartTime,
      userAddedStopTime: split.isOffPath,
      userAddedStopLoc: split.isOffPath,
      split: 1,
      stopTime: split.arrivalTime,
      stopLat: splitLat,
      stopLon: splitLon
    };
    const laterDataToClear = ['firstCompleted', 'lastPage', 'path', 'badStartTime', 'recordedStartTime'];
    const laterDataToUpdate = {
      completedCount: 0,
      complete: 0,
      queued: 0,
      matchedCount: 0,
      pickupMeters: 0,
      userEdited: surveyData.rosterAdded || split.isOffPath || surveyData.badStopLoc,
      teleport: split.isOffPath || surveyData.badStopLoc,
      userAddedStartTime: split.isOffPath,
      userAddedStartLoc: split.isOffPath,
      split: 1,
      startTime: split.departureTime,
      startLat: splitLat,
      startLon: splitLon
    };

    return this.incrementTourLegIds(surveyData.addedTourId, surveyData.addedLegId).then(() => {
      const newSurvey = Object.assign(earlierDataToRetain, earlierDataToUpdate);
      const updatedSurvey = Object.assign(surveyData, laterDataToUpdate);
      laterDataToClear.forEach((field) => {
        updatedSurvey[field] = null;
      }); // clear what needs to be cleared

      // we've incremented all legs of the tour after the original survey, but need to increment the second leg of the split
      if (updatedSurvey.rosterAdded) {
        updatedSurvey.addedLegId++;
      }

      promises.push(this.sqlHelper.getInsertPromise(this.db, this.table, newSurvey));
      promises.push(this.update(updatedSurvey));

      this.logger.info(
        'Splitting trip', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE,
        {
          legA: { startTime: newSurvey['startTime'], stopTime: newSurvey.stopTime },
          legB: { startTime: updatedSurvey.startTime, stopTime: updatedSurvey.stopTime }
        }
      );

      return Promise.all(promises);
    });
  }

  merge(earlier, later) {
    /*
            if mreging a trip, we keep the leg2 survey and delete the leg1 survey.
        */
    const earlierDataToRetain = this.utils.subset(earlier, [
      'pickupMeters',
      'badStartTime',
      'recordedStartTime',
      'userAddedStartTime',
      'userAddedStartLoc',
      'startTime',
      'startLat',
      'startLon'
    ]);
    let updatedSurvey: any;

    later.rosterAdded = earlier.rosterAdded === 1 && later.rosterAdded === 1 ? 1 : null; //need to know that there will be no points in locDb
    later.addedSuccess = later.addedSuccess || (!later.badStopLoc && !later.badStopTime) ? 1 : null;
    later.split = earlier.split === 1 || later.split === 1 ? 1 : null;
    later.complete = 0;
    later.queued = 0;
    later.merged = 1;

    updatedSurvey = Object.assign(later, earlierDataToRetain);

    /*
            adjusting leg id's
            if added -> clean					removing last leg of added tour. no need to shift ids
            if added -> different added tour 	removing last leg of added tour. no need to shift ids
            if added -> same added tour			merging into later leg. decrement later through last leg
            if clean -> added					merging into leg 1 of added tour. decrement all legs of tour
        */

    if (!later.rosterAdded || (later.rosterAdded && later.addedTourId !== earlier.addedTourId)) {
      // return Promise.all([this.delete(earlier.id), this.update(updatedSurvey)])
      //     .then(() => {
      //         return later;
      //     });
      return this.update(updatedSurvey)
        .then(() => this.delete(earlier.id))
        .then(() => later);
    }

    return this.decrementTourLegIds(later.addedTourId, later.addedLegId).then(() => {
      later.addedLegId--;
      return Promise.all([this.delete(earlier.id), this.update(later)]).then(() => later);
    });
  }

  incrementTourLegIds(tourId, splitLegId) {
    const self = this;
    const promises = [];
    const incrementLegId = (trip) => {
      trip.addedLegId++;
      promises.push(self.update(trip));
    };

    if (!tourId) {
      return Promise.resolve(null);
    }

    return this.getByTour(tourId, splitLegId + 1) //if splitting leg 3, increment legs 4+
      .then((trips: any) => {
        trips.forEach((trip) => {
          incrementLegId(trip);
        });

        return Promise.all(promises);
      });
  }

  decrementTourLegIds(tourId, laterLegId) {
    const self = this;
    const promises = [];
    const decrementLegId = function (trip) {
      trip.addedLegId--;
      promises.push(self.update(trip));
    };

    return this.getByTour(tourId, laterLegId + 1) //if merging leg 3 into leg 4, decrement legs 5+
      .then((trips: any[]) => {
        trips.forEach((trip) => {
          decrementLegId(trip);
        });

        return Promise.all(promises);
      });
  }

  /************************************************************************************
   * Trip matching
   ***********************************************************************************/

  getNearConditions = function (isStart, lat, lon, latRadius, lonRadius) {
    const colPrefix = isStart ? 'start' : 'stop';
    const out = {};
    out[colPrefix + 'Lat_BETWEEN'] = [lat - latRadius, lat + latRadius];
    out[colPrefix + 'Lon_BETWEEN'] = [lon - lonRadius, lon + lonRadius];
    return out;
  };

  // for order by
  getSquaredDistCol = function (isStart, lat, lon, lonFactor) {
    const colPrefix = isStart ? 'start' : 'stop';
    const latDiff = `(${colPrefix}Lat - ${lat})`;
    const lonDiff = `((${colPrefix}Lon - ${lon}) * ${lonFactor})`;
    return `(${latDiff} * ${latDiff}) + (${lonDiff} * ${lonDiff})`;
  };

  getMatchedSurvey = function (
    startLat,
    startLon,
    stopLat,
    stopLon,
    selectCols,
    notSurveyId,
    subjectPersonId,
    matchStart = false,
    moreWhere = {}
  ) {
    const nearLatRadius = this.gis.getNearLatInternalDegreesRadius();
    const nearLonRadius = this.gis.getNearLonInternalDegreesRadius((startLat + stopLat) / 2);
    const conditions = {
      complete: 1,
      hideFromUi: 0
    };
    Object.assign(conditions, this.getNearConditions(false, stopLat, stopLon, nearLatRadius, nearLonRadius));

    if (matchStart) {
      Object.assign(conditions, this.getNearConditions(true, startLat, startLon, nearLatRadius, nearLonRadius));
    }

    if (notSurveyId !== undefined) {
      conditions['id_NE'] = notSurveyId;
    }

    if (subjectPersonId) {
      conditions['subjectPersonId'] = subjectPersonId;
    }

    Object.assign(conditions, moreWhere);

    // get highest matchedCount- most likely to be matched again, best for count-check
    this.remoteLogger.addBreadcrumbs('getMatchedSurvey - Finding matched surveys', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, MSRemoteLoggerSeverity.INFO, {
      conditions,
      moreWhere
    });
    return this.sqlHelper
      .getSelectPromise(this.db, this.table, selectCols, conditions, 'matchedCount DESC, stopTime DESC', 1)
      .then((rows) => {
        this.logger.log('prepop getMatchedSurvey rows', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, rows.length);
        this.remoteLogger.addBreadcrumbs(
          `getMatchedSurvey - prepop getMatchedSurvey rows ${rows.length}`,
          MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE,
          MSRemoteLoggerSeverity.INFO
        );

        return rows.length === 0 ? null : rows[0];
      }).catch((error) => {
        this.remoteLogger.captureException(error);
      });
  };

  // TODO ORDER BY
  getPrepopSurvey = function (where, orderCols, orderBy) {
    const whereConditions = Object.assign({}, where, { complete: 1, hideFromUi: 0 });
    const cols = this.prepopulateFields.concat(orderCols);
    const ordering = orderBy || 'stopTime DESC';

    return this.sqlHelper.getSelectPromise(this.db, this.table, cols, whereConditions, ordering, 1).then((rows) => {
      this.logger.log('prepop getPrepopSurvey rows', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, rows.length);
      return rows.length === 0 ? null : rows[0];
    });
  };

  prepopulate(survey) {
    this.remoteLogger.addBreadcrumbs('prepopulate - Prepopulating survey', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, MSRemoteLoggerSeverity.INFO);

    // needs id, status, firstCompleted, start/stop lat/lon fields
    if (survey.complete === undefined) {
      const msg = 'prepopulate - Prepop needs to check complete';

      this.remoteLogger.addBreadcrumbs(msg, MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, MSRemoteLoggerSeverity.INFO);
      return Promise.reject(msg);
    } else if (survey.complete === 1) {
      const msg = "prepopulate - Won't prepop completed survey";

      this.remoteLogger.addBreadcrumbs(msg, MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, MSRemoteLoggerSeverity.INFO);
      return Promise.reject(msg);
    } else if (survey.firstCompleted !== null) {
      const msg = "prepopulate - Won't prepop previously completed survey";

      this.remoteLogger.addBreadcrumbs(msg, MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, MSRemoteLoggerSeverity.INFO);
      return Promise.reject(msg);
    }

    return Promise.all([
      this.getMatchedSurvey(
        survey.startLat,
        survey.startLon,
        survey.stopLat,
        survey.stopLon,
        this.prepopulateFields,
        survey.id,
        survey.subjectPersonId,
        true
      ),
      this.getMatchedSurvey(
        survey.startLat,
        survey.startLon,
        survey.stopLat,
        survey.stopLon,
        this.prepopulateFields,
        survey.id,
        survey.subjectPersonId,
        false
      )
    ]).then((results) => {
      const prepopTemplate = this.longDistanceMode ? results[1] : results[0];
      if (prepopTemplate) {
        this.logger.log('prepop template matches', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, prepopTemplate.matchedCount);
        this.remoteLogger.addBreadcrumbs(
          "prepopulate - prepop template matches ${prepopTemplate.matchedCount}",
          MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE,
          MSRemoteLoggerSeverity.INFO
        );

        prepopTemplate.matchedCount = prepopTemplate.matchedCount + 1;
        prepopTemplate.clonedId = prepopTemplate.id;
        delete prepopTemplate.id;
        return Object.assign({}, survey, prepopTemplate);
      } else {
        const msg = 'prepopulate - No prepop - unmatched';

        this.remoteLogger.addBreadcrumbs(msg, MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, MSRemoteLoggerSeverity.INFO);
        return Promise.reject(msg);
      }
    });
  }

  /************************************************************************************
   * LD auto trip matching
   ***********************************************************************************/

  autoConfirmPrepop(survey, tripMatchedCount) {
    // WARN preconditions for prepopulate; only call autoConfirmPrepop for creating new surveys
    survey.complete = 0;
    survey.firstCompleted = null;
    this.logger.log(
      'autoConfirmPrepop trip', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE,
      this.longDistanceMode,
      tripMatchedCount,
      '>=',
      CONSTANTS.surveyAutoConfirmCount,
      survey.matchedCount
    );

    if (this.longDistanceMode && tripMatchedCount >= CONSTANTS.surveyAutoConfirmCount) {
      survey.lastPage = null; // should only get here for new surveys
      return this.prepopulate(survey)
        .then((prepopData) => {
          this.logger.log('autoConfirmPrepop survey', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, prepopData.matchedCount, '>=', CONSTANTS.surveyAutoConfirmCount);
          // re-check in case something is out-of-date
          if (prepopData.matchedCount >= CONSTANTS.surveyAutoConfirmCount) {
            prepopData.complete = 1;
            return this.update(prepopData);
          }
          return Promise.resolve(0);
        })
        .catch((reason) =>
          // don't fail if we don't find a match (TODO - why no match?)
          Promise.resolve(null)
        );
    } else {
      return Promise.resolve(null);
    }
  }

  /************************************************************************************
   * Deleting
   ***********************************************************************************/

  // mark survey as deleted and queue it so latest survey info (and the delete flag) makes it to the server
  delete(surveyId) {
    const updates = { deleteFlag: 1, hideFromUi: 1, queued: 0 };
    return this.sqlHelper.getUpdatePromise(this.db, this.table, updates, { id: surveyId });
  }

  deleteAddedSurveys(tourId, minAddedLegId) {
    const updates = { deleteFlag: 1, hideFromUi: 1, queued: 0 };
    return this.sqlHelper.getUpdatePromise(this.db, this.table, updates, {
      addedTourId: tourId,
      addedLegId_GE: minAddedLegId,
      cloned_NULL: null
    });
  }

  deleteDuplicates(surveys) {
    const duplicateIds = [];
    const promises = [];

    for (let i = 0; i < surveys.length - 1; i++) {
      const s1 = surveys[i];
      const s2 = surveys[i + 1];
      if (
        s1.startTime === s2.startTime &&
        s1.stopTime === s2.stopTime &&
        s1.startLat === s2.startLat &&
        s1.startLon === s2.startLon &&
        s1.stopLat === s2.stopLat &&
        s1.stopLon === s2.stopLon
      ) {
        duplicateIds.push(s2.id);
      }
    }

    if (duplicateIds.length > 0) {
      this.logger.error('trip_survey_duplication_dashboard', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, duplicateIds);

      duplicateIds.forEach((id) => {
        promises.push(this.delete(id));
      });
    }

    return Promise.all(promises);
  }

  // dropAll: function () {
  //     return sqlHelper.getRawSqlPromise(db, 'DROP TABLE IF EXISTS ' + table);
  // },

  /************************************************************************************
   * Creating SD Surveys
   ***********************************************************************************/

  deleteSurvey(id) {
    // for dev
    return this.sqlHelper.getDeletePromise(this.db, this.table, { id });
  }

  createTripSurvey(trip, first = true) {
    let survey = {};
    const tripFieldsForSurvey = this.utils.subset(trip, [
      'startTime',
      'startLat',
      'startLon',
      'stopTime',
      'stopLat',
      'stopLon',
      'pickupMeters',
      'appDied',
      'locationTimeout',
      'timezoneOffset'
    ]);
    const badStopLoc = trip.appDied || (this.platform.is('ios') && trip.locationTimeout) ? 1 : null; // on android, don't flag locationTimeout as an error condition
    const avgSpeed = trip.afterPickupMeters / (trip.duration - 180);
    const distanceBeeline = this.gis.getDistance(
      this.gis.getFloatLatOrLon(trip.startLat),
      this.gis.getFloatLatOrLon(trip.startLon),
      this.gis.getFloatLatOrLon(trip.stopLat),
      this.gis.getFloatLatOrLon(trip.stopLon)
    );
    const totalDistance = trip.pickupMeters + trip.afterPickupMeters;
    const promptToSplit = first && badStopLoc === null && distanceBeeline < 100 && avgSpeed > 2.24 && totalDistance > 1619 ? 1 : null; // less than 100m beeline, over 5mph, and 1+ miles total
    let person;

    this.logger.log(
      'creating survey from trip', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE,
      'promptToSplit',
      promptToSplit,
      'distanceBeeline',
      distanceBeeline,
      'avgSpeed',
      avgSpeed,
      'totalDistance',
      totalDistance,
      'trip',
      trip
    );

    return Promise.all([this.persons.getDeviceOwner(), this.getAllForRoster()]).then((res) => {
      survey = Object.assign({}, tripFieldsForSurvey, {
        createdForTripId: trip.id,
        subjectPersonId: res[0].idx,
        surveyDate: trip.day,
        userEdited: trip.unknownStartTime || trip.unknownStopTime || badStopLoc || promptToSplit ? 1 : null,
        teleport: trip.unknownStartTime || trip.unknownStopTime || badStopLoc ? 1 : null,
        promptToSplit,
        badStartTime: trip.unknownStartTime,
        badStopTime: trip.unknownStopTime,
        badStopLoc,
        recordedStartTime: trip.recordedStartTime,
        recordedStopTime: trip.stopTime,
        firstStarted: this.dateTime.getNowSeconds(),
        adjustedStartTime: first ? trip.adjustedStartTime : null,
        startTime: first ? trip.adjustedStartTime || trip.startTime : trip.startTime
      });

      const message = `creating survey from trip, ${JSON.stringify(survey)}`
      this.debugLoggingCapsule.logIfAble(message);

      return this.sqlHelper.getInsertPromise(this.db, this.table, survey);
    });
  }

  wasCreatedFor(tripId) {
    return this.sqlHelper.getExistsPromise(this.db, this.table, { createdForTripId: tripId });
  }

  /************************************************************************************
   * Creating LD Surveys
   ***********************************************************************************/

  isSurveyed(trip) {
    // for survey creation err checks only
    // assume true for "don't know" - we don't want to add duplicate surveys
    return trip.hasSurvey === undefined || trip.hasSurvey === 1;
  }

  getLdStopInfo(lastTrip, survey) {
    // default our stop data to the recorded stop data for the segment
    const stopInfo = {
      stopTime: lastTrip.stopTime,
      stopLat: lastTrip.stopLat,
      stopLon: lastTrip.stopLon
    };

    // if the last segment has dwell data and the dwell occurs after the final trip survey start time, then use the dwell data
    // in the case of a split survey, the dwell can occur during a prior segment, so we need to confirm it falls within the survey times
    if (
      lastTrip.dwellCenterLat != null &&
      lastTrip.dwellCenterLon != null &&
      lastTrip.dwellCenterTime != null &&
      lastTrip.dwellCenterTime >= survey.startTime
    ) {
      stopInfo.stopTime = lastTrip.dwellCenterTime;
      stopInfo.stopLat = lastTrip.dwellCenterLat;
      stopInfo.stopLon = lastTrip.dwellCenterLon;
    }

    return stopInfo;
  }

  createSplitSurveys(trips) {
    // round trip info happens to be on the last trip
    const self = this;
    const lastTrip = trips[trips.length - 1];
    const splitStart = {
      startTime: lastTrip.splitTime,
      startLat: lastTrip.splitLat,
      startLon: lastTrip.splitLon,
      recordedStartTime: lastTrip.recordedStartTime
    };
    const splitStop = { stopTime: lastTrip.splitTime, stopLat: lastTrip.splitLat, stopLon: lastTrip.splitLon };
    const tripStart = this.utils.subset(trips[0], ['startTime', 'startLat', 'startLon', 'recordedStartTime']);
    const tripStop = this.getLdStopInfo(lastTrip, splitStart);
    const vetFirstHalf =
      splitStop.stopTime - tripStart['startTime'] > this.dateTime.getSeconds(CONSTANTS.LD_MAX_DURATION_HOURS, 0, 0) ? 1 : null;
    const vetSecondHalf =
      tripStop['stopTime'] - splitStart.startTime > this.dateTime.getSeconds(CONSTANTS.LD_MAX_DURATION_HOURS, 0, 0) ? 1 : null;
    const firstHalfMeta = {
      userEdited: vetFirstHalf,
      teleport: vetFirstHalf,
      badStartTime: vetFirstHalf,
      badStopTime: vetFirstHalf,
      recordedStartTime: tripStart['recordedStartTime'],
      recordedStopTime: splitStop.stopTime,
      surveyDate: parseInt(moment(splitStop.stopTime, 'X').format('YYYYMMDD'), 10),
      timezoneOffset: trips[0]['timezoneOffset'],
      split: 1
    };
    const secondHalfMeta = {
      userEdited: vetSecondHalf,
      teleport: vetSecondHalf,
      badStartTime: vetSecondHalf,
      badStopTime: vetSecondHalf,
      recordedStartTime: splitStart.recordedStartTime,
      recordedStopTime: tripStop['stopTime'],
      surveyDate: parseInt(moment(tripStop['stopTime'], 'X').format('YYYYMMDD'), 10),
      timezoneOffset: lastTrip['timezoneOffset'],
      split: 1
    };
    const subject = { subjectPersonId: this.persons.deviceOwner.idx };
    const firstHalf = Object.assign({}, subject, tripStart, splitStop, firstHalfMeta);
    const secondHalf = Object.assign({}, subject, splitStart, tripStop, secondHalfMeta);
    const promises = [];
    const pushPromise = function (survey, matchedCount) {
      promises.push(
        self.sqlHelper
          .getInsertPromise(self.db, self.table, survey)
          .then((insertedId) => {
            survey.id = insertedId;
          })
          .then(() => self.autoConfirmPrepop(survey, matchedCount))
      );
    };

    if (this.isSurveyed(lastTrip)) {
      throw 'Call a split fn for surveys instead';
    }
    if (firstHalf.stopTime < firstHalf.startTime || secondHalf.stopTime < secondHalf.startTime) {
      return Promise.reject('Negative trip duration'); // WARN text must match trip survey initializer check
    }

    //logger.log('createSplitSurveys', trips);
    pushPromise(firstHalf, lastTrip.matchedCount0);
    pushPromise(secondHalf, lastTrip.matchedCount1);

    return Promise.all(promises);
  }

  createMergedSurvey(trips) {
    const lastTrip = trips[trips.length - 1];
    const beginning = this.utils.subset(trips[0], ['startTime', 'startLat', 'startLon', 'recordedStartTime']);
    const end = this.getLdStopInfo(lastTrip, beginning);
    const vetTimes = end['stopTime'] - beginning['startTime'] > this.dateTime.getSeconds(CONSTANTS.LD_MAX_DURATION_HOURS, 0, 0) ? 1 : null;
    const tripMeta = {
      userEdited: vetTimes,
      teleport: vetTimes,
      badStartTime: vetTimes,
      badStopTime: vetTimes,
      recordedStopTime: end['stopTime'],
      surveyDate: end['day'],
      timezoneOffset: end['timezoneOffset']
    };
    const survey = Object.assign({}, beginning, end, tripMeta, {
      matchedCount: lastTrip.matchedCount0,
      subjectPersonId: this.persons.deviceOwner.idx
    });

    if (trips.some(this.isSurveyed)) {
      throw 'Call mergeSurveys instead';
    }

    if (survey.stopTime < survey.startTime) {
      return Promise.reject('Negative trip duration'); // WARN text must match trip survey initializer check
    }

    //logger.log('createMergedSurvey', trips);
    return this.sqlHelper
      .getInsertPromise(this.db, this.table, survey)
      .then((insertedId) => {
        survey.id = insertedId;
      })
      .then(() => this.autoConfirmPrepop(survey, lastTrip.matchedCount0))
      .then(() => survey);
  }

  autoCreateSurveys(trips) {
    const roundTripInfoTrip = trips[trips.length - 1]; // happens to be on end
    //logger.log('autoCreateSurveys', trips);
    if (roundTripInfoTrip.splitTime !== null) {
      return this.createSplitSurveys(trips);
    } else {
      return this.createMergedSurvey(trips);
    }
  }

  /************************************************************************************
   * Creating User-added Surveys
   ***********************************************************************************/

  createUserAddedSurvey(survey) {
    return this.sqlHelper.getInsertPromise(this.db, this.table, survey);
  }

  copyProxySurveys(targetDay, surveyIds) {
    const promises = [];

    surveyIds.forEach((id) => {
      promises.push(
        this.get(id).then((survey) => {
          const startMoment = moment(survey.startTime, 'X');
          const stopMoment = moment(survey.stopTime, 'X');
          const startClone = startMoment.clone();
          const dayDiff = startClone.startOf('day').diff(targetDay.moment.startOf('day'), 'days'); // can copy from past or future.
          delete survey.id;
          survey.startTime = startMoment.subtract(dayDiff, 'days').unix();
          survey.stopTime = stopMoment.subtract(dayDiff, 'days').unix();
          survey.surveyDate = moment(survey.stopTime, 'X').format('YYYYMMDD');
          survey.firstCompleted = null;
          survey.lastCompleted = null;
          survey.completedCount = null;
          survey.cloned = 1;
          survey.queued = 0;
          return this.createUserAddedSurvey(survey).then((id) => {
            // this was the easiest way to set firstCompleted and lastCompleted to now.
            survey.id = id;
            return this.update(survey);
          });
        })
      );
    });

    return Promise.all(promises);
  }

  /************************************************************************************
   * Getting
   ***********************************************************************************/

  get(id) {
    return this.sqlHelper.getSelectPromise(this.db, this.table, ['*'], { id }).then((rows) => rows[0]);
  }

  getByPersonId(pId) {
    return this.sqlHelper.getSelectPromise(this.db, this.table, ['*'], { subjectPersonId: pId, hideFromUi: 0 }, 'startTime ASC');
  }

  getByPersonIdForRoster(pId) {
    return this.sqlHelper.getSelectPromise(
      this.db,
      this.table,
      this.rosterFields,
      { subjectPersonId: pId, hideFromUi: 0 },
      'startTime ASC'
    );
  }

  getByPersonIdForVerify(pId) {
    return this.sqlHelper.getSelectPromise(
      this.db,
      this.table,
      this.verifyFields,
      { subjectPersonId: pId, hideFromUi: 0 },
      'startTime ASC'
    );
  }

  getAll() {
    // TODO - only get roster fields? pull out dummy trips or seed or something
    return this.sqlHelper.getSelectPromise(this.db, this.table, ['*'], { hideFromUi: 0 }, 'startTime ASC');
  }

  getAllForRoster() {
    // TODO - only get roster fields? pull out dummy trips or seed or something
    // return this.sqlHelper.getSelectPromise(this.db, this.table, this.rosterFields, {hideFromUi: 0}, 'startTime ASC');
    return this.sqlHelper.getSelectPromise(this.db, this.table, this.rosterFields, { hideFromUi: 0 }, 'startTime ASC');
  }

  getFirstLegOfAddedTour(tourId) {
    return this.sqlHelper.getSelectPromise(this.db, this.table, ['*'], { addedTourId: tourId, addedLegId: 1 }).then((rows) => rows[0]);
  }

  getByTour(tourId, minLegId?) {
    return this.sqlHelper.getSelectPromise(
      this.db,
      this.table,
      ['*'],
      { addedTourId: tourId, hideFromUi: 0, addedLegId_GE: minLegId ? minLegId : 1 },
      'startTime ASC'
    );
  }

  getLatestSurveyByPersonId(subjectPersonId, stopBefore: number = 0) {
    const where = { subjectPersonId, hideFromUi: 0, stopTime_NOTNULL: null };
    if (stopBefore > 0) {
      where['stopTime_LT'] = stopBefore;
    }
    return this.sqlHelper.getSelectPromise(this.db, this.table, ['*'], where, 'stopTime DESC', 1).then((rows) => rows[0]);
  }

  getPreviousSurveyByTraveler(currStartSeconds, person, stopAfterSeconds) {
    const where = { stopTime_LE: currStartSeconds, hideFromUi: 0 };

    if (person.participant) {
      return Promise.resolve(null);
    }

    if (stopAfterSeconds !== undefined) {
      where['stopTime_GE'] = stopAfterSeconds;
    }

    where['_CB_householders_' + person.idx] = 1;
    return this.sqlHelper.getSelectPromise(this.db, this.table, this.mergeFields, where, 'stopTime DESC', 1).then((rows) => rows[0]);
  }

  getPreviousSurveyBySubject(currStartSeconds, person, stopAfterSeconds) {
    const where = { stopTime_LE: currStartSeconds, hideFromUi: 0, subjectPersonId: person.idx };

    if (stopAfterSeconds !== undefined) {
      where['stopTime_GE'] = stopAfterSeconds;
    }

    return this.sqlHelper.getSelectPromise(this.db, this.table, this.mergeFields, where, 'stopTime DESC', 1).then((rows) => rows[0]);
  }

  getPreviousSurvey(currStartSeconds, person, stopAfterSeconds) {
    return Promise.all([
      this.getPreviousSurveyBySubject(currStartSeconds, person, stopAfterSeconds),
      this.getPreviousSurveyByTraveler(currStartSeconds, person, stopAfterSeconds)
    ]).then((results) =>
      !results[0] && !results[1]
        ? null
        : !results[0]
          ? results[1]
          : !results[1]
            ? results[0]
            : results[0].startTime > results[1].startTime
              ? results[0]
              : results[1]
    );
  }

  getNextSurveyByTraveler(currStopSeconds, person) {
    const whereObj = { startTime_GE: currStopSeconds, hideFromUi: 0 };

    if (person.participant) {
      return Promise.resolve(null);
    }

    whereObj['_CB_householders_' + person.idx] = 1;
    return this.sqlHelper.getSelectPromise(this.db, this.table, this.mergeFields, whereObj, 'startTime ASC', 1).then((rows) => rows[0]);
  }

  getNextSurveyBySubject(currStopSeconds, person) {
    return this.sqlHelper
      .getSelectPromise(
        this.db,
        this.table,
        this.mergeFields,
        { startTime_GE: currStopSeconds, hideFromUi: 0, subjectPersonId: person.idx },
        'startTime ASC',
        1
      )
      .then((rows) => rows[0]);
  }

  getNextSurvey(currStopSeconds, person) {
    return Promise.all([this.getNextSurveyBySubject(currStopSeconds, person), this.getNextSurveyByTraveler(currStopSeconds, person)]).then(
      (results) =>
        !results[0] && !results[1]
          ? null
          : !results[0]
            ? results[1]
            : !results[1]
              ? results[0]
              : results[0].startTime < results[1].startTime
                ? results[0]
                : results[1]
    );
  }

  getSurveysByTraveler(pIdx) {
    const whereObj = { hideFromUi: 0 };
    whereObj['_CB_householders_' + pIdx] = 1;

    // return this.sqlHelper.getSelectPromise(this.db, this.table, ['*'], whereObj, 'startTime ASC', 1).then(rows => { return rows[0] });
    return this.sqlHelper.getSelectPromise(this.db, this.table, ['*'], whereObj, 'startTime ASC');
  }

  // getNextSurveyForMerge: function (currStopSeconds) {
  //     return sqlHelper.getSelectPromise(db, table, mergeFields, {startTime_GE: currStopSeconds, hideFromUi: 0}, 'startTime ASC', 1).then(function (rows) { return rows[0]; });
  // },

  getDataForController(id) {
    const self = this;
    const data = {
      survey: { startTime: -1, stopTime: -1, subjectPersonId: -1 },
      earlier: {},
      later: {},
      translationData: { name: '' },
      isLongDistance: false,
      isProxySurvey: false,
      dateDisplay: '',
      timeDisplay: '',
      startTimeDisplay: '',
      stopTimeDisplay: ''
    };

    return this.get(id)
      .then((res: any) => {
        data.survey = res;
        data.isLongDistance = self.longDistanceMode;
        data.dateDisplay = moment(data.survey.startTime, 'X').format('ll');
        data.startTimeDisplay = moment(data.survey.startTime, 'X').format('LT');
        data.stopTimeDisplay = moment(data.survey.stopTime, 'X').format('LT');
        data.timeDisplay = data.startTimeDisplay + ' - ' + data.stopTimeDisplay;

        return this.persons.getPersonById(res.subjectPersonId);
      })
      .then((res) => {
        data.isProxySurvey = res.participant === false;
        data.translationData.name = res.name;
        return Promise.all([
          self.getPreviousSurvey(data.survey.startTime, res, undefined),
          self.getNextSurvey(data.survey.startTime + 1, res)
        ]);
      })
      .then((results) => {
        data.earlier = results[0];
        data.later = results[1];
        return data;
      });
  }

  /************************************************************************************
   * Queueing
   ***********************************************************************************/

  markQueued(id) {
    return this.sqlHelper.getUpdatePromise(this.db, this.table, { queued: 1 }, { id });
  }

  getUnqueuedIds() {
    return this.sqlHelper.getSelectPromise(this.db, this.table, ['id'], { queued: 0 });
  }

  hasUnqueued() {
    // including unfinished
    return this.sqlHelper.getExistsPromise(this.db, this.table, { queued: 0 });
  }

  /************************************************************************************
   * Initializing
   ***********************************************************************************/

  getCreateTableSql() {
    const dbColDefs = [];

    return this.schema.parse(CONSTANTS.surveyTypes.TRIP).then((fields: any[]) => {
      this.rosterFields = [].concat(this.baseRosterFields);
      this.prepopulateFields = [].concat(this.basePrepopulateFields);
      fields.forEach((field) => {
        const name = field[0];
        const type = field[1];
        const isRoster = field[2];
        dbColDefs.push(name + ' ' + type);
        // we have hidden fields in the trip survey for startLabel, stopLabel, copied, and copiedId. We don't want to overwrite these when prepopulating
        // TODO - add these fields as base metadata fields and remove as hidden fields
        if (!this.prepopulateFieldsToIgnore.includes(name)) {
          this.prepopulateFields.push(name);
        }
        if (isRoster) {
          this.rosterFields.push(name);
        }
      });
      this.logger.log('rosterFields', MSRemoteLoggerCategory.TRIP_SURVEY_SERVICE, this.rosterFields);
      return this.createTableSql + dbColDefs.join(', ') + ');';
    });
  }

  initialize(isLongDistance) {
    this.longDistanceMode = isLongDistance;

    return this.sqlHelper
      .createDb({ name: CONSTANTS.mainFrontEndDbName, location: 'default', androidDatabaseProvider: 'system', androidLockWorkaround: 1 })
      .then((db) => {
        this.db = db;
        return this.getCreateTableSql();
      })
      .then((res) => this.sqlHelper.createTablePromise(this.db, res));
  }

  deleteInvalidSurveys(surveys) {
    return this.deleteDuplicates(surveys).then(() =>
      // It's a workaround for surveys with stopTime or startTime invalid dates
      // It needs Telemetry implementation to start tracking the origin of survey invalid dates
      // Reference: https://dev.azure.com/ResourceSystemsGroup/rMove/_workitems/edit/2749
      this.deleteInvalidDatesSurveys(surveys)
    );
  }

  private deleteInvalidDatesSurveys(surveys) {
    const deletePromises = [];
    surveys.forEach((survey) => {
      if (!(moment(survey.startTime, 'X').isValid() && moment(survey.stopTime, 'X').isValid())) {
        deletePromises.push(this.delete(survey.id));
      }
    });
    return Promise.all(deletePromises);
  }
}
